import { CRRender } from '@/components/crRender'
import ImgPopup from '@/components/popups/imgPopup'
import { translate } from '@/utils/langUtils'
import { Icon } from '@iconify/react'

const ProviderDocs = ({ documents }) => {

    return (
        <div className="submitted-documents">
            <h3 className="submitted-documents-title">{translate('submitted-documents')}</h3>
            <div className="documents-grid">
                {documents.mapWithKey((doc) => (
                    <div className="document-card" key={doc.key}>
                        <Icon
                            icon={doc.status === "approved" ? "mdi:file-check" : "mdi:file-clock"}
                            className={`document-icon ${doc.status}`}
                        />
                        <span className="document-name">{doc.name}</span>
                        {
                            // @ts-ignore
                            <>
                                <CRRender isRender={!doc.data[doc?.data?.length - 1]?.name.includes('.pdf')}>
                                    <ImgPopup sourcePath={window.WEB_LINK} link={doc.data[doc?.data?.length - 1].name} />
                                </CRRender>
                                <CRRender isRender={doc.data[doc?.data?.length - 1]?.name.includes('.pdf')}>
                                    <a href={window.WEB_LINK + doc.data[doc?.data?.length - 1].name} target="_blank" rel="noopener noreferrer">
                                        {translate('open-file-details')}
                                        <Icon icon="mdi:file-pdf" className="document-icon" />
                                    </a>
                                </CRRender>
                            </>
                        }
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ProviderDocs